//获取滚动条当前的位置 
const getScrollTop = () => {
    var scrollTop = 0;
    if (document.documentElement && document.documentElement.scrollTop) {
        scrollTop = document.documentElement.scrollTop;
    }
    else if (document.body) {
        scrollTop = document.body.scrollTop;
    }
    return scrollTop;
}

//获取当前可是范围的高度 
const getClientHeight = () => {
    var clientHeight = 0;
    if (document.body.clientHeight && document.documentElement.clientHeight) {
        clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight);
    }
    else {
        clientHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight);
    }
    return clientHeight;
}

//获取文档完整的高度 
const getScrollHeight = () => {
    return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);1
}
//时间格式 非今年显示yyyy-mm-dd 今年显示m m-dd
const fomateDate2 = date => {
    let time = new Date(date)
    let year=time.getFullYear()
    let nowYear = new Date().getFullYear();
    
    let month=(time.getMonth()+1)<10?'0'+(time.getMonth()+1):time.getMonth()+1
    let dates=time.getDate()<10?'0'+time.getDate():time.getDate()
    return  (year == nowYear)? (month+'-'+dates) : year+'-'+month+'-'+dates
}

const formatTime = date => {
    let getdata = new Date(date);
    let year = getdata.getFullYear()
    let month = getdata.getMonth() + 1
    let day = getdata.getDate()
    let hour = getdata.getHours()
    let minute = getdata.getMinutes()
    let second = getdata.getSeconds()

    return [year, month, day].map(formatNumber).join('/')
    //  + ' ' + [hour, minute, second].map(formatNumber).join(':')
}


//时间格式 yyyy-mm-dd

const timeFormat=timestamp=>{
  //timestamp是整数，否则要parseInt转换,不会出现少个0的情况
  var time = new Date(timestamp);
  var year = time.getFullYear();
  var month = time.getMonth()+1;
  var date = time.getDate();
  var hours = time.getHours();
  var minutes = time.getMinutes();
  var seconds = time.getSeconds();
  return year+'-'+add0(month)+'-'+add0(date)+' '+add0(hours)+':'+add0(minutes)+':'+add0(seconds);
}
function add0(m){return m<10?'0'+m:m }

const fomateDate = date => {
    let time = new Date(date)
    let year=time.getFullYear()
    let month=(time.getMonth()+1)<10?'0'+(time.getMonth()+1):time.getMonth()+1
    let dates=time.getDate()<10?'0'+time.getDate():time.getDate()
    return year+'-'+month+'-'+dates
}
// MM/DD
const fomateDateMount = date => {
    let time = new Date(date)
    let month=(time.getMonth()+1)<10?'0'+(time.getMonth()+1):time.getMonth()+1
    let dates=time.getDate()<10?'0'+time.getDate():time.getDate()
    return month+'/'+dates
}
const formatTimeDate = date => {
    let getdata = new Date(date);
    const year = getdata.getFullYear()
    const month = getdata.getMonth() + 1
    const day = getdata.getDate()
    const hour = getdata.getHours()
    const minute = getdata.getMinutes()
    const second = getdata.getSeconds()

    return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':')
}

const formatNumber = n => {
    n = n.toString()
    return n[1] ? n : '0' + n
}

// 判断字符数 中文字符占2个长度
const strlen = (str) => {
    let len = 0;
    for (let i = 0; i < str.length; i++) {
        let c = str.charCodeAt(i);
        //单字节加1   
        if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
            len++;
        }
        else {
            len += 2;
        }
    }
    return len;
}

const getTargetLenStr = (str, targetLen) =>{
    let len = 0;
    for (let i = 0; i < str.length; i++) {
        let c = str.charCodeAt(i);
        //单字节加1   
        if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
            len++;
            if(len > targetLen){
                return len - 1;
            }
        } else {
            len += 2;
            if(len > targetLen){
                return len - 2;
            }
        }
    }
    return len;
}

// 获取文件格式
const getFileSuffix = (filename) => {
    return filename.substring(filename.lastIndexOf('.') + 1).toLowerCase();
}

//节流函数（稀释函数调用次数）
const debounce =  function(func,delay=100){
  let timer = null
  return function (...args) {
    if(timer){
      clearTimeout(timer);
    } 
    timer = setTimeout(() => {
      func.apply(this,args);
    },delay)
  }
}
  

export { fomateDate2, timeFormat,debounce,formatTime,fomateDate,fomateDateMount,formatTimeDate, getScrollTop, getClientHeight, getScrollHeight, strlen, getTargetLenStr, getFileSuffix }


// WEBPACK FOOTER //
// ./src/util/util.js